import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import DataTable from "../../../components/common/datatable/DataTable";
import ButtonComponent from "../../../components/common/button/Button";

export const DataDetails = (
  {data,
  // rowSelection,
  // onSelectionChanged,
  pagination,
  paginationPageSize,
  paginationPageSizeSelector,
  gridApiRef: parentGridApiRef,
}) => {
  const [isGridReady, setIsGridReady] = useState(false);
  const [columnState, setColumnState] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState("");
  const [disableFilterBtn, setDisableFilterBtn] = useState(true);

  const renderExpandableText = (params, maxLength = 50) => {
    const text = params.value || ""; // The error details text
    const isLongText = text.length > maxLength;

    // Initialize the showFullText property for the row if not already set
    if (!params.node.showFullText) {
      params.node.showFullText = false;
    }

    const toggleText = () => {
      params.node.showFullText = !params.node.showFullText;
      params.api.refreshCells({ rowNodes: [params.node], force: true }); // Refresh the cell to update the UI
    };

    return isLongText ? (
      <div>
        {params.node.showFullText ? (
          <>
            <span>{text}</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              Less
            </button>
          </>
        ) : (
          <>
            <span>{text.substring(0, maxLength)}...</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              More
            </button>
          </>
        )}
      </div>
    ) : (
      <span>{text}</span>
    );
  };

  const columnData = useMemo(() => {
    if (data?.packagingAuditList) {
      return [
        {
          headerName: "Material Number",
          field: "ccMaterialNo",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Material Type",
          field: "materialType",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Material Description",
          field: "materialDescription",
          width: 210,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Vendor Number",
          field: "vendorNumber",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Number",
          field: "supplierItemNo",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Name",
          field: "supplierName",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Description",
          field: "supplierDescription",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Allocation Qty",
          field: "allocationQty",
          width: 200,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Allocation Notes",
          field: "allocationNotes",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Currency",
          field: "currency",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          width: 220,
        },
        {
          headerName: "Division",
          field: "division",
          width: 210,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "From Date",
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "To Date",
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "ForeCast File",
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "From Qty",
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "To Qty",
          field: "toQty",
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Incoterms",
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Last Updated",
          field: "lastChange",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Last Updated Time",
          field: "lastUpdateTimestamp",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Location Name",
          field: "locationName",
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Manager Name",
          field: "managerName",
          // width: 230,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Manufacturing LeadTime",
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "MOQ Comments",
          field: "moqComments",
          initialWidth: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: "Named Place",
          field: "namedPlace",
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Open PO",
          field: "openpo",
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Payment Description",
          field: "paymentDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Per Qty",
          field: "perQty",
          // width: 230,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Plant Id",
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Plant Name",
          field: "plantName",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Price",
          field: "price",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Pricememo Type",
          field: "priceMemoType",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          // pinned: "right",
        },
        {
          headerName: "Sap Payment Term",
          field: "sapPaymentTerm",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          // pinned: "right",
        },
        {
          headerName: "Resolved Time",
          field: "resolvedTimestamp",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          // pinned: "right",
        },
        {
          headerName: "User Name",
          field: "userName",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          // pinned: "right",
        },
        {
          headerName: "User Id",
          field: "userId",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          // pinned: "right",
        },
        {
          headerName: "UOM",
          field: "uom",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          // pinned: "right",
        },
        {
          headerName: "Status",
          field: "status",
          // width: 180,
          sortable: true,
          resizable: true,
          unSortIcon: true,
          pinned: "right",
        },
      ];
    } else if (data?.cepgAuditList) {
      return [
        {
          headerName: "Material Number",
          field: "material",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "GMP Lead",
          field: "gmpLead",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Proc Org",
          field: "procOrg",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Year",
          field: "year",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Division",
          field: "division",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Plant Id",
          field: "plantId",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Plant Name",
          field: "plantName",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Description",
          field: "description",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "S-code",
          field: "scode",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Number",
          field: "supplierNumber",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Supplier Name",
          field: "supplierName",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Manager Name",
          field: "manager",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Product Category",
          field: "productCategory",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Pin",
          field: "pin",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Package Size",
          field: "packSize",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Price",
          field: "price",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Currency",
          field: "currency",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "UOM",
          field: "uom",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "incoTerms",
          field: "incoTerms",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Named Place",
          field: "namedPlace",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "From Qty",
          field: "fromQty",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "To Qty",
          field: "toQty",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Effective From Date",
          field: "effectiveFrom",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Effective To Date",
          field: "effectiveTo",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Payment Term",
          field: "paymentTerm",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Manufacturing LeadTime",
          field: "manufacturingLeadTime",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Allocation Qty (Kg)",
          field: "allocationQtyKg",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Change Date",
          field: "changeDate",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "MOQ Comments",
          field: "moqComments",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Allocation Notes",
          field: "allocationNotes",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Picasso Facility",
          field: "picassoFacility",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Last Update Time",
          field: "lastUpdateTimestamp",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "User Id",
          field: "userId",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "User Name",
          field: "userName",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Open PO",
          field: "openpo",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Forecast File",
          field: "foreCastFile",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Resolved Time",
          field: "resolvedTimestamp",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Price Memo Type",
          field: "priceMemoType",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
        {
          headerName: "Status",
          field: "status",
          // width: 240,
          sortable: true,
          resizable: true,
          unSortIcon: true,
        },
      ]
    };
  }, [data]);

  const selectionColumnDef = useMemo(
    () => ({
      pinned: "left",
    }),
    [],
  );

  const gridApiRef = useRef(null);

  const onColumnChange = (e) => {
    const col = e.target.value;
    setSelectedColumn(col);
    if (col && gridApiRef.current) {
      gridApiRef.current.ensureColumnVisible(col);
    }
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api; // Store the grid API instance locally
    // Also set the parent component's gridApiRef if passed as prop
    if (parentGridApiRef) {
      parentGridApiRef.current = params.api;
    }
    setIsGridReady(true);
    if (columnState) {
      params.columnApi.applyColumnState({
        state: columnState,
        applyOrder: true,
      });
    }
  };

  useEffect(() => {
    // Restore filter model from localStorage on component mount
    if (isGridReady && gridApiRef?.current) {
      const savedFilterModel = localStorage.getItem(
        "cdAuditLogsModel",
      );
      if (savedFilterModel) {
        gridApiRef.current.setFilterModel(JSON.parse(savedFilterModel));
        setDisableFilterBtn(true); // Enable the "Clear All Filters" button
      }
    }
  }, [isGridReady]);

  const clearAllFilters = () => {
    if (gridApiRef.current) {
      gridApiRef.current.setFilterModel(null); // Clear all filters
      localStorage.removeItem("cdAuditLogsModel");
      setDisableFilterBtn(true);
    }
  };

  const onFilterChanged = () => {
    if (gridApiRef.current) {
      const filterModel = gridApiRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0); // Enable button if filters exist
      localStorage.setItem(
        "cdAuditLogsModel",
        JSON.stringify(filterModel),
      );
    }
  };

  const onColumnMoved = useCallback((params) => {
    if (
      params &&
      params.columnApi &&
      typeof params.columnApi.getColumnState === "function"
    ) {
      setColumnState(params.columnApi.getColumnState());
    }
  }, []);

  const gridOptions = {
    getRowId: (params) => {
      return `${params?.data?.historyId}`;
    },
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: "agMultiColumnFilter",
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
          if (!params.data) return "";

          const field = params.colDef.field;
          const value = params.data[field];

          return value === null || value === undefined || value === "" ? "" : value;
      },
    },
    onColumnMoved,
    onFilterChanged,
    getContextMenuItems: () => {
      return ['copy', 'copyWithHeaders', 'paste', 'separator', 'autoSizeAll', 'resetColumns'];
    },
  };

  // const handleExportToExcel = () => {
  //   if (!gridApiRef.current) return;

  //   // Get all displayed columns currently in the grid
  //   const allColumns = gridApiRef.current.getAllDisplayedColumns();

  //   // Filter out the columns you want to exclude
  //   const columnsForExport = allColumns
  //     .filter(col => col.getColId() !== 'statusIcon')
  //     .map(col => col.getColId()); // Get just the IDs

  //   // Call the export API with the specific column keys
  //   gridApiRef.current.exportDataAsExcel({
  //     columnKeys: columnsForExport,
  //   });
  // }

  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <InputLabel>Jump to Column</InputLabel>
            <Select
              id="col-select"
              value={selectedColumn}
              label="Jump to Column"
              onChange={onColumnChange}
            >
              <MenuItem value="">Select Column</MenuItem>
              {columnData?.map((col) => (
                <MenuItem key={col?.field} value={col?.field}>
                  {col?.headerName || col?.field}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* <ButtonComponent
            label="Export to Excel"
            bgColor="black"
            color="white"
            onClick={handleExportToExcel}
          /> */}
        </div>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
          <ButtonComponent
            maxWidth="150px"
            label="Clear All Filters"
            bgColor="black"
            color="white"
            disabled={disableFilterBtn}
            onClick={clearAllFilters}
          />
        </div>
      </div>
      <DataTable
        columns={columnData}
        rows={data?.packagingAuditList || data?.cepgAuditList || []}
        paginationProp={pagination}
        paginationPageSize={paginationPageSize}
        paginationPageSizeSelector={paginationPageSizeSelector}
        selectionColumnDef={selectionColumnDef}
        // rowSelection={rowSelection}
        // onSelectionChanged={onSelectionChanged}
        gridOptions={gridOptions}
        onGridReady={onGridReady}
      />
    </>
  );
};
